/* eslint-disable react/prop-types */

import { useTheme } from '@emotion/react';
import { Breadcrumbs, Typography, Box } from '@mui/material';
import React, { memo } from 'react';
import { Link } from 'react-router';

interface BreadcrumbItem {
  name: string;
  to?: string;
  color?: string;
}

interface DataFormate {
  title?: string;
  links?: BreadcrumbItem[];
  color?: string;
};

interface BreadcrumbProps {
  data?: DataFormate;
  separator?: React.ReactNode;
}

export const GenericBreadcrumb = memo(
  ({
    data,
    separator = '/',
  }: BreadcrumbProps) => {
    const theme: any = useTheme();

    if (!data) return null;

    const items = [
      ...(data.links || []),
      ...(data.title ? [{ name: data.title }] : []),
    ];

    return (
      <Box mb={1.5}>
        <Breadcrumbs separator={separator} aria-label="breadcrumb">
          {items.map((item, index) => {
            const { color: itemColor } = item;
            const isLast = index === items.length - 1;
            const color =
              itemColor ||
              (isLast
                ? data.color || 'text.primary'
                : theme?.palette?.neutral?.greyText ||
                theme?.palette?.text?.secondary ||
                '#666666');
            return isLast ? (
              <Typography
                key={`crumb-${item.name}}`}
                style={{
                  color,
                  fontWeight: 600,
                  fontSize: '13px',
                  marginTop: '2px',
                }}
                variant="body2">
                {item.name}
              </Typography>
            ) : (
              <Link
                key={`crumb-${item.name}}`}
                to={item.to || '/'}
                style={{
                  color,
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: 600,
                }}>
                {item.name}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Box>
    );
  },
);
